module.exports = __webpack_public_path__ + "img/Hivelogo.f589b75a.svg";